import { subscribeOnAuthentication } from 'shared/eventsLogs/consumers/subscribeOnAuthentication';
import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

import { createContext } from './createContext';

export function runApp(): void {
  const context = createContext();

  const store = createApplicationState(context);

  store.dispatch(subscribeOnAuthentication());

  renderApplication({ context, store });
}
